import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSignup = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 672,
	height: 896,
	viewBox: "0 0 672 896",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3668_65163)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M1.52588e-05 -4.85172e-06C61.8656 -2.17177e-06 112 50.1532 112 112C112 173.866 61.8468 224 5.37874e-06 224L1.52588e-05 -4.85172e-06Z",
				fill: "#FD8F52"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M224 224C162.134 224 112 173.847 112 112C112 50.1341 162.153 5.98071e-07 224 1.33559e-06L224 224Z",
				fill: "#FD8F52"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M224 4.85172e-06H0.033334C61.8836 0.018013 112 50.1643 112 112C112 173.866 61.8468 224 0 224L224 224C162.134 224 112 173.847 112 112C112 50.1341 162.153 9.26449e-06 224 4.85172e-06Z",
				fill: "#C7DAFF"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 224,
				height: 224,
				transform: "translate(224)",
				fill: "#FD8F52"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M448 -4.85172e-06C509.866 -2.17177e-06 560 50.1532 560 112C560 173.866 509.847 224 448 224L448 -4.85172e-06Z",
				fill: "#FD8F52"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M560 -4.85172e-06C621.866 -2.17177e-06 672 50.1532 672 112C672 173.866 621.847 224 560 224L560 -4.85172e-06Z",
				fill: "#FD8F52"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M448 0C448.011 4.81123e-10 448.022 1.6178e-06 448.033 4.85172e-06L448 0ZM560 112C560 50.1643 509.884 0.018013 448.033 4.85172e-06H560L560 112ZM448 224H560L560 112C560 173.866 509.847 224 448 224Z",
				fill: "#105ED5"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M560 0C560.011 4.81123e-10 560.022 1.6178e-06 560.033 4.85172e-06L560 0ZM672 112C672 50.1643 621.884 0.018013 560.033 4.85172e-06H672L672 112ZM560 224H672L672 112C672 173.866 621.847 224 560 224Z",
				fill: "#105ED5"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 224,
				height: 224,
				transform: "translate(0 224)",
				fill: "#FFE6D9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M224 224L224 448L448 448C448 324.306 347.731 224 224 224Z",
				fill: "#FFE6D9"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M448 224H224C347.731 224 448 324.306 448 448V224Z",
				fill: "#105ED5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M560 224L448 224L448 336C509.847 336 560 285.866 560 224Z",
				fill: "#105ED5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M672 336V224H560C560 285.847 610.134 336 672 336Z",
				fill: "#105ED5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M448 336L448 448L560 448C560 386.153 509.866 336 448 336Z",
				fill: "#105ED5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M560 448L672 448L672 336C610.153 336 560 386.134 560 448Z",
				fill: "#105ED5"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M672 336C610.134 336 560 285.847 560 224C560 285.866 509.847 336 448 336C509.866 336 560 386.153 560 448C560 386.134 610.153 336 672 336Z",
				fill: "#FFE6D9"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 224,
				height: 224,
				transform: "translate(0 448)",
				fill: "#FD8F52"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M224 448L224 672L448 672C448 548.306 347.731 448 224 448Z",
				fill: "#FD8F52"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M448 448H224C347.731 448 448 548.306 448 672V448Z",
				fill: "#C7DAFF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M560 448L448 448L448 560C509.847 560 560 509.866 560 448Z",
				fill: "#FFE6D9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M672 560V448H560C560 509.847 610.134 560 672 560Z",
				fill: "#FFE6D9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M448 560L448 672L560 672C560 610.153 509.866 560 448 560Z",
				fill: "#FFE6D9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M560 672L672 672L672 560C610.153 560 560 610.134 560 672Z",
				fill: "#FFE6D9"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M672 560C610.134 560 560 509.847 560 448C560 509.866 509.847 560 448 560C509.866 560 560 610.153 560 672C560 610.134 610.153 560 672 560Z",
				fill: "#FD8F52"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M112 784L224 784L224 672C162.153 672 112 722.134 112 784Z",
				fill: "#105ED5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M112 896L224 896L224 784C162.153 784 112 834.134 112 896Z",
				fill: "#105ED5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.34769e-06 784L112 784L112 672C50.1532 672 6.03263e-07 722.134 1.34769e-06 784Z",
				fill: "#105ED5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.34769e-06 896L112 896L112 784C50.1532 784 6.03263e-07 834.134 1.34769e-06 896Z",
				fill: "#105ED5"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M112 784H224C162.153 784 112 834.134 112 896V784ZM0 896C2.51061e-06 834.134 50.1532 784 112 784C112 722.134 162.153 672 224 672H112H0V896ZM112 672V784H3.25503e-06C2.51061e-06 722.134 50.1532 672 112 672Z",
				fill: "#C7DAFF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M224 896L448 896L448 672C324.306 672 224 772.269 224 896Z",
				fill: "#105ED5"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M448 672H224V896C224 772.269 324.306 672 448 672Z",
				fill: "#C7DAFF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M672 672C672 733.866 621.847 784 560 784C498.134 784 448 733.847 448 672L672 672Z",
				fill: "#FFE6D9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M448 896C448 834.134 498.153 784 560 784C621.866 784 672 834.153 672 896H448Z",
				fill: "#FFE6D9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M672 672.059C671.968 733.897 621.827 784 560 784C498.146 784 448.019 733.866 448 672.035V896C448 834.134 498.153 784 560 784C621.866 784 672 834.153 672 896V672.059Z",
				fill: "#105ED5"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3668_65163",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 672,
			height: 896,
			rx: 32,
			fill: "white"
		})
	}) })]
});
export { SvgSignup as ReactComponent };
